import React from 'react';

import clsx from 'classnames';
import PropTypes from 'prop-types';

import {
    capitalize,
    combineClasses,
} from 'wanderu-css';

// eslint-disable-next-line css-modules/no-unused-class
import styles from './Section.scss';

function Section(props) {
    const {
        children,
        className,
        classes: classesProps = {},
        color,
        component: Component = 'section',
        componentProps = {},
        ...otherProps
    } = props;

    const classes = combineClasses(styles, classesProps);

    return (
        <Component
            className={clsx(
                classes.root,
                {
                    [classes[`color${capitalize(color)}`]]: color,
                },
                className,
            )}
            {...otherProps}
            {...componentProps}
        >
            <div className={classes.content}>
                {children}
            </div>
        </Component>
    );
}

Section.propTypes = {
    /**
     * The content of the component.
     */
    children: PropTypes.node.isRequired,
    /**
     * Override or extend the styles applied to the component.
     */
    classes: PropTypes.object,
    /**
     * @ignore
     */
    className: PropTypes.string,
    /**
     * Sets section background color, also updates text color where appropriate.
     */
    color: PropTypes.oneOf(['primary', 'grey', 'light']),
    /**
    * The component used for the root node.
    * Either a string to use a HTML element or a component.
    */
    component: PropTypes.elementType,
    /**
     * The set of component props passed down to the root component
     */
    componentProps: PropTypes.object,
};

export default Section;
